
import { Button } from "@/components/ui/button";
import { Mail, Plus } from "lucide-react";

type EmptyMailboxStateProps = {
  onAddClick: () => void;
};

export function EmptyMailboxState({ onAddClick }: EmptyMailboxStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="bg-primary/10 p-3 rounded-full mb-4">
        <Mail className="h-8 w-8 text-primary" />
      </div>
      <h3 className="text-lg font-medium mb-2">No mailboxes linked yet</h3>
      <p className="text-muted-foreground mb-6 max-w-md">
        Connect your Microsoft mailboxes to start creating automated reply rules.
      </p>
      <Button onClick={onAddClick}>
        <Plus className="h-4 w-4 mr-2" />
        Add Mailbox
      </Button>
    </div>
  );
}
